module.exports = __webpack_public_path__ + "img/Image Container (1).d3cb7723.png";